var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave-sync-status-cell"},[(!_vm.program?.contentSync)?_c('SyncSwitch',{attrs:{"sm":true,"syncStatus":false,"onToggle":null}}):_c('SyncSwitch',{attrs:{"sm":true,"syncStatus":_vm.wave.contentSync,"onToggle":_vm.changeContentSyncStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }